import React from "react";
import "./Contact.css";

const Contact = (props)=>{
    return(
        <>
            <center>
                <div className="contact-page" style={{color : props.mode === 'dark' ? "white" : "black"}}>
                    <div className="contact-title">
                        <h1>Text Me</h1>
                        <p>I'd love to hear from you.</p>
                    </div>
                    <form className="form" method="POST" data-netlify="true">
                        <div className="input row form-row">
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                                <input type="text" name="name" id="text" placeholder="Full Name" style={{backgroundColor : props.mode === 'dark' ? "#454646" : "white", 
                            
                            color : props.mode === 'dark' ? "white" : "black",

                            border : props.mode === 'dark' ? "1px solid white" : "1px solid grey",
                            
                            borderRadius : props.mode === 'dark' ? "5px" : "5px",

                            outline : props.mode === 'dark' ? "none" : "none",

                            }} required/>
                            </div>
                            <div className="col-md-4"></div>
                        </div>
                        <div className="input form-row">
                            
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                            <input type="email" name="email" id="email" placeholder="Email"
                            style={{backgroundColor : props.mode === 'dark' ? "#454646" : "white", 
                            
                            color : props.mode === 'dark' ? "white" : "black",

                            border : props.mode === 'dark' ? "1px solid white" : "1px solid grey",
                            
                            borderRadius : props.mode === 'dark' ? "5px" : "5px",

                            outline : props.mode === 'dark' ? "none" : "none",

                            }}
                            required/>
                            </div>
                            <div className="col-md-4"></div>
                        </div>
                        <div className="text-box form-row">
                            
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                            <textarea name="message" id="textarea" cols="29" rows="10" placeholder="Message"
                            
                            style={{backgroundColor : props.mode === 'dark' ? "#454646" : "white", 
                            
                            color : props.mode === 'dark' ? "white" : "black",

                            border : props.mode === 'dark' ? "1px solid white" : "1px solid grey",
                            
                            borderRadius : props.mode === 'dark' ? "5px" : "5px",

                            outline : props.mode === 'dark' ? "none" : "none",

                            }}
                            ></textarea>
                            </div>
                            <div className="col-md-4"></div>
                        </div>
                        <div className="buttons">
                        <div className="form-row">  
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                            <button className={`btn btn-outline-${props.textMode} btn-block mx-1 btn-send`} type="submit">Send</button>
                            <button className={`btn btn-outline-${props.textMode} btn-block mx-1 btn-mode`} onClick={props.handleMode}>{props.displayTextMode} Mode</button>
                            </div>
                            <div className="col-md-4"></div>
                        </div>
                        </div>
                    </form>
                            
                    <div className="spacer"></div>
                        <p>--------------------------------</p>

                        {/* <div className="spacer"></div> */}

                        <div className="row ending-text">
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                                <p>"Connecting with others is always beneficial, so let's do just that as we explore the technical industry"</p>
                                <p>- Sannu</p>
                            </div>
                            <div className="col-md-4"></div>
                        </div>

                        {/* <div className="small-spacer"></div> */}
                        <p>--------------------------------</p>


                </div>

            </center>
        </>
    );
}

export default Contact;